import React, { useEffect, ChangeEvent, FormEvent, Fragment, useMemo, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { RegisterLabels } from "../../assets/labels/labels";
import { IconClient, IconSquareChecked, IconSquareUnchecked } from "../../assets/svgs-index";
import ModalInformation from "../../components/Modals/ModalInformation";
import PoweredBy from "../../components/PoweredBy/PoweredBy";
import ButtonDivider from "../../components/buttons/ButtonDivider/ButtonDivider";
import LinkButton from "../../components/buttons/LinkButton/LinkButton";
import PasswordField from "../../components/input/PasswordField";
import { AuthenticationService } from "../../core/services/authentication.service";
import { Helper, HelperConfig, HelperWebView } from "../../core/services/helper/helper.service";
import LoginProvider from "./LoginProvider";
import { CompanyService } from "../../core/services/company.service";
import Emitter from "../../core/services/emitter";
import AndroidBack from "../../core/services/androidBack.service";


declare global {
  interface OTPCredential extends Credential {
    code: string;
  }
  interface Window {
    receiveOTP: (otp: string) => void;
  }
}

interface ExtendedCredentialRequestOptions extends CredentialRequestOptions {
  otp?: {
    transport: string[];
  };
  signal?: AbortSignal;
}

const Register: React.FC<any> = () => {
  const cookies = useMemo(() => new Cookies(), []);
  const location = useLocation();
  const navigate = useNavigate();
  const open_appointment = location?.state?.openAppointment || cookies.get("openAppointment");
  const domain = location?.state?.domain || cookies.get("kssreturncompany")?.replace(".qa", "");
  const searchParams = new URLSearchParams(location.search);
  const isEmbedded = Helper.isEmbedded();

  const [modalInfoIsOpen, setModalInfoIsOpen] = useState<boolean>(false);
  const [modalInfoMessage, setModalInfoMessage] = useState<string>("");
  const [modalInfoSubMessage, setModalInfoSubMessage] = useState<string>("");
  const [modalInfoTitle, setModalInfoTitle] = useState<string>("");
  const [modalInfoConfirmText, setModalInfoConfirmText] = useState<string>("");
  const [modalInfoOnConfirm, setModalInfoOnConfirm] = useState<() => void>();
  const [modalShowClose, setShowClose] = useState<boolean>(false);

  


  const [iAgree, setIAgree] = useState<boolean>(false);
  const [errorIAgree, setErrorIAgree] = useState<boolean>(location?.state?.errorIAgree === true);
  const [signUpWarningSent, setSignUpWarningSent] = useState<boolean>(false); //para aviso ser dado apenas 1x
  
  useEffect(() => {
    if (errorIAgree) {
      setErrorIAgree(true);
      setTimeout(() => {
        setErrorIAgree(false);
      }, 10000);
    }
  }, [errorIAgree]);

  const setEmailParam = () => {
    if (!searchParams.get("fromLite") && !cookies.get("fromLite")) {
      cookies.remove("liteToken", HelperConfig.cookiesLiteConfig);
      cookies.remove("userId", HelperConfig.cookiesLiteConfig);
      cookies.remove("liteEmail", HelperConfig.cookiesLiteConfig);
      cookies.remove("litePhone", HelperConfig.cookiesLiteConfig);
      cookies.remove("isCalToken", HelperConfig.cookiesLiteConfig);
    }
    if (searchParams.get("fromLite")) {cookies.set("fromLite", true, HelperConfig.cookiesLiteConfig);}
    return searchParams.get("email") || location?.state?.email || '';
  }

  const [email, setEmail] = useState<string>(() => setEmailParam());
  const [phone, setPhone] = useState<string>(searchParams.get("phone") || location?.state?.phone || '');
  const phoneRef = useRef(phone);
  const [inputUsernameValue, setInputUsernameValue] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [inputPhoneCode, setInputPhoneCode] = useState<string>("");
  const [phoneCode, setPhoneCode] = useState<string>("");
  const [phoneLoginLoading, setPhoneLoginLoading] = useState<boolean>(false);
  const [phoneCodeRequested, setPhoneCodeRequested] = useState<Boolean>(false);
  const [phoneCodeRequestSuccess, setPhoneCodeRequestSuccess] = useState<string>("");
  const [checkPassword, setCheckPassword] = useState<string>("");
  const [validateNowPassword, setValidateNowPassword] = useState<Boolean>(false);
  const [validateNowCheckPassword, setValidateNowCheckPassword] = useState<Boolean>(false);
  const [passwordValid, setPasswordValid] = useState<Boolean>(false);
  const [checkPasswordValid, setCheckPasswordValid] = useState<Boolean>(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /(^(003519\d{8})$)|(^\+3519\d{8}$)|(^(?!00|0|\+)[9]\d{8}$)/;
  const phoneCodeRegex = /(^(?!\+|00)\d{6,}$)/;

  useEffect(() => {
    phoneRef.current = phone;
  }, [phone]);

  useEffect(() => {
    setInputUsernameValue(phone ? phone : email ? email : '');
    if (HelperWebView.isAndroidWebview()) {
      const handleRegisterBack = () => {
        navigate('/');
      };
      Emitter.on('REGISTER_BACK', handleRegisterBack);

      AndroidBack.setIsRegister(true);

      return () => {
        Emitter.off('REGISTER_BACK', handleRegisterBack);
        // Reset setIsLogin to false
        AndroidBack.setIsRegister(false);
      };
    }

    //Get Company details for iagree
    // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    // Only set this up for an Android webview environment
    if (HelperWebView.isAndroidWebview()) {
      // Define the function
      window.receiveOTP = (otp: string) => {
        setPhoneCodeDirectly(otp);
      };
      // Cleanup function to remove the function from window
      return () => {
        delete (window as any).receiveOTP;
      };
    }
    // eslint-disable-next-line 
  }, []);

  let abortController = new AbortController();

  const receiveOtpBrowser = async () => {
    const options: ExtendedCredentialRequestOptions = {
      otp: { transport: ['sms'] },
      signal: abortController.signal,
    };

    if ('OTPCredential' in window) {
      try {
        const content = await navigator.credentials.get(options) as OTPCredential;
        setPhoneCodeDirectly(content.code);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const iAgreeNotSet = () => {
    setErrorIAgree(true);
    setTimeout(() => {
      setErrorIAgree(false);
    }, 10000);
  };

  const tryStartOtpAndroid = () => {
    if (HelperWebView.isAndroidWebview()) {
      try {
        (window as any).Android.startOtpAndroid();
      } catch (error) {
        console.error(error);
      }
    }
  }

  const handleChangeUsername = (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setInputUsernameValue(input);
    if (emailRegex.test(input)) {
      setEmail(input);
      setPhone('');
    } else if (phoneRegex.test(input)) {
      setPhone(input);
      setEmail('');
    } else {
      setEmail('');
      setPhone('');
    }
    if (phoneCodeRequested) {
      setPhoneCodeRequested(false);
      setIAgree(false);
    }
  };

  const handleChangePassword = (value: string) => {
    setPassword(value);
  };
  const handleChangeCheckPassword = (value: string) => {
    setCheckPassword(value);
  };

  const handleEmailSignup = () => {
    if (checkPasswordValidation(password, checkPassword)) {
      if (signUpWarningSent) {
        onEmailSignup();
      } else {
        signUpWarning(true, true);
        setSignUpWarningSent(true);
      }
    }
  };

  const signUpWarning = (shouldSignUpOnClose: boolean = true, showClose: boolean = false) => {
    setModalInfoTitle("Utilize o e-mail que forneceu ao seu prestador de serviços.");
    setModalInfoMessage("Se tiver serviços contratados connosco,");
    setModalInfoSubMessage("utilize o mesmo **e-mail**, para aceder a todas as suas intervenções.");
    setModalInfoConfirmText("De acordo. Quero continuar.");
    if (shouldSignUpOnClose) setModalInfoOnConfirm(() => onEmailSignup);
    setShowClose(showClose);
    setModalInfoIsOpen(true);
  }

  const onEmailSignup = () => {
    closeModal();
    let body: { email: string; password: string; user_id?: string; work_token?: string, domain?: string, work_email?: string, work_phone?: string, open_appointment?: boolean, is_cal_token?: string; terms_accepted?:boolean} = {
      email,
      password,
      terms_accepted: iAgree,
    };
    if (location.state?.userId ||cookies.get("userId")) {
      body = {
        ...body,
        user_id: location.state?.userId || cookies.get("userId"),
        domain: domain,
        work_token: location.state?.liteToken || cookies.get("liteToken"),
        work_email: location.state?.liteEmail || cookies.get("liteEmail"),
        work_phone: location.state?.litePhone || cookies.get("litePhone"),
        is_cal_token: location.state?.isCalToken || cookies.get("isCalToken"),
      };
    } else {
      if (domain !== null) {
        body = {
          ...body,
          domain: domain,
        };
      }
    }
    if (open_appointment) {
      body = {
        ...body,
        open_appointment: open_appointment,
      }
    }
    AuthenticationService.signUpUser(body, navigate).then((response) => {
      if (response) {
        setModalInfoTitle(response.title);
        setModalInfoMessage(response.message);
        setModalInfoSubMessage(response.subMessage);
        setModalInfoConfirmText(response.confirmText);
        response.onConfirm === "emailConfirm" && setModalInfoOnConfirm(() => handleConfirmEmail);
        setModalInfoIsOpen(true);
      }
    });
  };

  const handleConfirmEmail = () => {
    closeModal();
    let body: { email: string; password: string; user_id?: string; work_token?: string, domain?: string, work_email?: string, work_phone?: string, open_appointment?: boolean, is_cal_token?: string; } = {
      email,
      password,
    };
    if (location.state?.userId ||cookies.get("userId")) {
      body = {
        ...body,
        user_id: location.state?.userId || cookies.get("userId"),
        domain: domain,
        work_token: location.state?.liteToken || cookies.get("liteToken"),
        work_email: location.state?.liteEmail || cookies.get("liteEmail"),
        work_phone: location.state?.litePhone || cookies.get("litePhone"),
        is_cal_token: location.state?.isCalToken || cookies.get("isCalToken"),
      };
    } else {
      if (domain !== null) {
        body = {
          ...body,
          domain: domain,
        };
      }
    }
    if (open_appointment) {
      body = {
        ...body,
        open_appointment: open_appointment,
      }
    }
    AuthenticationService.sendEmailConfirmation(body, navigate).then((response) => {
      if (response) {
        setModalInfoTitle(response.title);
        setModalInfoMessage(response.message);
        setModalInfoConfirmText(response.confirmText);
        setModalInfoIsOpen(true);
      }
    });
  };

  const checkPasswordValidation = (password: string, passwordConfirm: string) => {
    if (password === passwordConfirm) {
      return true;
    }
    setModalInfoTitle("Dados Incorrectos");
    setModalInfoMessage("As passwords inseridas são diferentes");
    setModalInfoSubMessage("");
    setModalInfoConfirmText("Ok");
    setModalInfoOnConfirm(undefined);
    setModalInfoIsOpen(true);
    return false;
  };


  const renderModalInformation = (handler: any) => {
    if (!modalInfoIsOpen) {
      return <Fragment />;
    }
    return (
      <ModalInformation
        modalIsOpen={modalInfoIsOpen}
        title={modalInfoTitle}
        message={modalInfoMessage}
        subMessage={modalInfoSubMessage}
        confirmText={modalInfoConfirmText}
        onClose={() => closeModal()}
        onConfirm={handler || closeModal}
        showClose={modalShowClose}
      />
    );
  };

  const closeModal = () => {
    setModalInfoIsOpen(false);
    setModalInfoTitle("");
    setModalInfoMessage("");
    setModalInfoSubMessage("");
    setModalInfoConfirmText("");
    setModalInfoOnConfirm(undefined);
    setShowClose(true);
  };

  const renderDeleteAccountLink = () => {
    return (
      <>{HelperWebView.isIOSWebview() && <div className="w-100 d-flex align-center">
        <LinkButton
          onClick={() => {
            navigate("/help-delete-account");
          }}
          styleClass="link-container mt-5"
          textClass="small"
          valueText="E se mais tarde quiser apagar a minha conta?"
        />
      </div>
      }</>
    );
  }

  const goToLogin = () => {
    let url = "/login";
    if (isEmbedded) {
      url += `?embedded=${encodeURIComponent(isEmbedded)}`;
    }
    navigate(url, { state: { email, phone } });
  }

  const renderGoToLoginLink = () => {
    return (<>
      { <div className="w-100 d-flex align-center"
             ref={inputRef}
        >
        <LinkButton
          onClick={() => goToLogin()}
          styleClass="link-container mt-4"
          valueText={RegisterLabels.linkMessage}
        />
      </div>}
    </>);
  }

  const renderIAgree = () => {
    return (
      <>
        <div className="input-label mt-4 i-agree-container" style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', height: 'auto', whiteSpace: 'nowrap' }}>
          <label htmlFor="agreeCheckbox" className="i-agree-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={iAgree}
              onChange={handleCheckboxChange}
              id="agreeCheckbox"
              className="agree-checkbox"
              style={{ cursor: 'pointer', transform: 'scale(1.3)', display: iAgree ? 'none' : 'inline-block' }}  // Hide the default checkbox
            />
            <span
            className="custom-checkbox"
            style={{
              width: '20px',
              height: '20px',
              display: iAgree ? 'inline-block' : 'none',
              backgroundImage: iAgree ? `url(${IconSquareChecked})` : `url(${IconSquareUnchecked})`,
              backgroundSize: 'cover',
              marginRight: '0px',
              marginLeft: '-6px',
              cursor: 'pointer',
            }}
            />
            <span style={{ paddingRight: '0px', paddingLeft: '8px', cursor: 'pointer', fontSize: '15px'}}>Li e concordo </span>
            <span style={{ paddingRight: '4px', paddingLeft: '3px', cursor: 'pointer'}}> com a</span>
          </label>
          <div className="i-agree-link" style={{ flexShrink: 0 }}>
            <LinkButton
              onClick={() => Emitter.emit("OPEN_IAGREE_TEXT", null)}
              styleClass="link-container"
              textClass="small light"
              valueText={"Política de Privacidade e Condições Gerais"}
            />
          </div>
        </div>
        {errorIAgree &&
         <div  style={{ fontSize: '12px', color: 'red' }} >
          Por favor, leia e aceite a Política de Privacidade
        </div>
        }
      </>
    );
  };

  const setPhoneCodeDirectly = (code: string) => {
    setInputPhoneCode(code);
    if (phoneCodeRegex.test(code)) {
      setPhoneCode(code);
      //if(iAgree) {onPhoneLogin(phoneRef.current, code);}
    } else {
      setPhoneCode('');
    }
  };

  const handleChangePhoneCode= (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setInputPhoneCode(input);
    if (phoneCodeRegex.test(input)) {
      setPhoneCode(input);
      //if(iAgree) {onPhoneLogin(phone, input);}
    }else {
      setPhoneCode('');
    }
  };

  const handlePhoneLogin : React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    onPhoneLogin(phone, phoneCode);
  }


  const onPhoneLogin = (phone?: string, code?: string) => {
    setPhoneLoginLoading(true);
    let body: { user_id?: string; work_token?: string;
                domain?: string; work_email?: string; work_phone?: string;  open_appointment?: boolean; is_cal_token?: string; phone?: string; code?: string; terms_accepted?:boolean } 
      = {
      phone,
      code,
      terms_accepted: iAgree,
    };
    if (location.state?.userId ||cookies.get("userId")) {
      body = {
        ...body,
        user_id: location.state?.userId || cookies.get("userId"),
        domain: domain,
        work_token: location.state?.liteToken || cookies.get("liteToken"),
        work_email: location.state?.liteEmail || cookies.get("liteEmail"),
        work_phone: location.state?.litePhone || cookies.get("litePhone"),
        is_cal_token: location.state?.isCalToken || cookies.get("isCalToken"),
      };
    } else {
      if (domain !== null) {
        body = {
          ...body,
          domain: domain,
        };
      }
    }
    if (open_appointment) {
      body = {
        ...body,
        open_appointment: open_appointment,
      }
    }
    AuthenticationService.authenticateUserPhone(body, navigate).then((response) => {
      if (response) {
        if (response.type === "Failure" || response.code) {
          setPhoneCodeRequestSuccess("Failure");
          const timer = setTimeout(() => {
            setPhoneCodeRequestSuccess("RequestAfterFailure");
          }, 3000);
          if (response.code && response.code !== '2'){
            setModalInfoTitle("Pedido Sem Sucesso");
            setModalInfoMessage("Foi encontrado um problema durante o pedido, por favor tente mais tarde.");
            setModalInfoConfirmText("OK");
            setModalInfoIsOpen(true);
          }
          // Cleanup function in case the component unmounts before the timer completes
          return () => clearTimeout(timer);
        }
      }
    });
    setTimeout(() => {
      setPhoneLoginLoading(false);
    }, 1000);
  };

  const handlePhoneCodeRequest : React.MouseEventHandler<HTMLElement> = (e) => {
    e.preventDefault();
    onPhoneCodeRequest(phone);
    setInputPhoneCode("");
    setPhoneCode("");
  }

  const onPhoneCodeRequest = (phone: string, terms_accepted?: boolean) => {
    const platform = HelperWebView.isAndroidWebview() ? "ANDROID" : 
                      HelperWebView.isIOSWebview() ? "IOS" : 
                      "WEB";
    terms_accepted = terms_accepted ?? iAgree; // Default to iAgree if terms_accepted is undefined               
    const body: { phone: string, platform: string, terms_accepted?:boolean } = { phone, platform, terms_accepted };
    AuthenticationService.requestPhoneCode(body, navigate).then((response) => {
      if (response) {
        if (response.type === "Success") {
          setPhoneCodeRequested(true);
          setPhoneCodeRequestSuccess("Success");
          receiveOtpBrowser(); //Listen to OTP on mobile browser
          tryStartOtpAndroid(); //Listen to OTP on Android app
          const timer = setTimeout(() => {
            setPhoneCodeRequestSuccess("");
          }, 5000);
          // Cleanup function in case the component unmounts before the timer completes
          return () => clearTimeout(timer);
        } else {
          setPhoneCodeRequested(false);
          setModalInfoTitle("Tente novamente");
          setModalInfoMessage("Ocorreu um erro a enviar SMS com código de autenticação.");
          setModalInfoSubMessage("Tente novamente dentro de momentos.");
          setModalInfoConfirmText("OK");
          setModalInfoIsOpen(true);

        }
      }
      });
  };

  const renderUsernameInput = () => {
    // Define the onKeyDown event handler
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
  //   event.preventDefault();
      if (event.key === 'Enter' && !phoneCodeRequested && phone) { onPhoneCodeRequest(phone); }
      if (event.key === 'Enter' && email) {
        // Find all focusable elements, ensure each is an HTMLElement.
        const focusableElementsSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableElements = Array.from(document.querySelectorAll(focusableElementsSelector))
          .filter((elem): elem is HTMLElement => elem instanceof HTMLElement && !elem.hasAttribute('disabled'));

        const currentIndex = focusableElements.indexOf(event.target as HTMLElement);
        const nextIndex = (currentIndex + 1) % focusableElements.length;
        const nextElement = focusableElements[nextIndex];

        nextElement.focus();
      }
     
   };
    return (
      <div className="input-container">
        <p className="input-label">E-mail ou Nº de Telemóvel</p>
        <input
          className="input-medium-default"
          type="text"
          title="E-mail ou Nº de Telemóvel de Portugal"
          value={inputUsernameValue}
          placeholder="E-mail ou Nº de Telemóvel de Portugal"
          onChange={handleChangeUsername}
          onKeyDown={handleKeyDown}
          autoComplete="off"
        />
      </div>
    );
  }
  
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFocus = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }, 300); // Adjust the delay time as needed
  };

  const renderSMSCodeInput = () => {
    return (<>
      { phone && phoneCodeRequested && iAgree && <>
        <div className="input-container mt-3">
          {/*<p className="input-label">Introduza o código recebido por SMS</p>*/}
          <input
            className={`input-medium-default unique-letter-spacing bigPlaceholder
            ${phoneCodeRequestSuccess === "Success" ? "success" :
            phoneCodeRequestSuccess === "Failure" ? "failure" : ''
            }`}
            type="text"
            name="one-time-code"
            id="sms-code"
            inputMode="numeric" 
            pattern="[0-9]*"
            autoComplete="one-time-code" 
            maxLength={6}
            aria-label="One time password"
            //autoFocus
            title="Código rebido por SMS"
            value={inputPhoneCode}
            placeholder="Introduza o código recebido por SMS"
            onChange={handleChangePhoneCode}
            onFocus={handleFocus}
          />
        </div>
        <div
          className={`link-container mt-1 ${phoneCodeRequestSuccess === "Success" ? "success" :
            phoneCodeRequestSuccess === "Failure" ? "failure" : ''
            }`}
          onClick={phoneCodeRequestSuccess === 'RequestAfterFailure' ? handlePhoneCodeRequest : undefined}
        >
          {
            phoneCodeRequestSuccess === "Success" ? "" : //"Enviámos-lhe um Código por SMS." :
              phoneCodeRequestSuccess === "Failure" ? "Código inválido ou expirado." :
                phoneCodeRequestSuccess === "RequestAfterFailure" ? "Enviem-me novo código SMS!" : ""
          }
        </div>

      </>
      }
    </>);
  }

  //Botão fictício para aparecer sempre que não estejam disponíveis outros botões
  const renderDummyContinuarButton = () => { 
    return;
    /*return (<>
      {//!phoneCodeRequested &&
       (!(phone || email) || !iAgree) &&
        <button className="cta-button-primary disabled d-medium w-100 mt-4">
          Continuar
        </button>
      }
    </>);*/
  }

  const renderRequestPhoneOTPButton = () => {
    return;
    /*return(<>
      {!phoneCodeRequested && phone && iAgree &&
      <button className="cta-button-primary d-medium w-100 mt-4" onClick={handlePhoneCodeRequest} type="button">
        Continuar
      </button>}
    </>)*/
  }

  const renderLoginPhoneButton = () => {
    return (<>
      {phone && phoneCodeRequested && iAgree &&
        <button className={`cta-button-primary d-medium w-100 mt-4 ${(!phoneCode || phoneLoginLoading)? "disabled" : "" }`}
          onClick={handlePhoneLogin} 
          type="button"
          disabled={!phoneCode || phoneLoginLoading}
          >
          Entrar
        </button>
      }
    </>)
  }

  const handlePasswordFormSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();  // Prevent default form submission
    if (!passwordValid) {
      setValidateNowPassword(true);
    } else if (!checkPasswordValid) {
      setValidateNowCheckPassword(true);
    } else {
      handleEmailSignup();
    }
  }

  const handleValidationCompletePassword = (isValid: boolean, doNotSubmit = false) => {
    if (isValid) {
      setPasswordValid(true);
      if (checkPasswordValid && !doNotSubmit) { handleEmailSignup(); }
    } else {
      setPasswordValid(false);
    }
    setValidateNowPassword(false);
  };

  const handleValidationCompleteCheckPassword = (isValid: boolean, doNotSubmit = false) => {
    if (isValid) {
      setCheckPasswordValid(true);
      if (passwordValid && !doNotSubmit) { handleEmailSignup(); }
    } else {
      setCheckPasswordValid(false);
    }
    setValidateNowCheckPassword(false);
  };

  const renderEmailPasswordFieldAndButton = () => {
    return (<>
      {email && iAgree &&
        <form onSubmit={handlePasswordFormSubmit}>
        <PasswordField password={password} 
                      onChange={handleChangePassword} 
                      validateNow={validateNowPassword}
                      onValidationComplete={handleValidationCompletePassword}
                      autoComplete="new-password" />
        <PasswordField
                      password={checkPassword}
                      onChange={handleChangeCheckPassword}
                      validateNow={validateNowCheckPassword}
                      onValidationComplete={handleValidationCompleteCheckPassword}
                      label={"Confirmar Password"}
        />
        <button className="cta-button-primary d-medium w-100 mt-4" type="submit">Registar</button>
        </form>
      }
    </>)
  }


    // Function to handle checkbox change
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setIAgree(event.target.checked);
      if (event.target.checked && phone){
        //Call OTP automatically
        onPhoneCodeRequest(phone, event.target.checked);
      }
    };

    const returnToLite = () => {
      const returnUrl = cookies.get("redirectAuthFallback");
      if (returnUrl) {
        window.open(returnUrl, '_self');
      }
    }

    const renderEmbeddedHeader = () => {
      return (
        <>
          <div className="header w-100 d-flex flex-row justify-content-between ps-md-9 opacity-50">
            <div className="logo-container d-flex flex-column">
              <div className="company-logo mt-2 mx-3 mx-md-4">
                <img className="kmclient-logo"
                src={domain ? CompanyService.urlCompanyImage(`domain/${domain}`) : IconClient}
                alt="logo"
                onError={(e) => ((e.target as HTMLImageElement).src = IconClient)} />
              </div>
            </div>
            <div className="app-logo-container me-3 me-md-4 align-items-center">
              {" "}
              <PoweredBy isTop={true}/>
            </div>
          </div>
        </>
      )
    }
    
    const containerStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)', // semi-transparent background
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000, // Ensure it's on top of other elements
      maxWidth: 'none',
  
    };
  
    const iframeContainerStyle = {
      width: '96%',
      height: '200%',
      backgroundColor: '#fff',
      borderRadius: '8px',
      //overflow: 'hidden',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      position : 'relative',
    };
  
    const closeButtonStyle: React.CSSProperties = {
      top: '10px',
      right: '10px',
      width: '36px',
      height: '36px',
      color: 'black',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontSize: '24px',
      fontWeight: 'bold',
      lineHeight: '24px',
      position: 'absolute',
    };
  

    const embeddedContainerStyle = isEmbedded ? containerStyle : {};
    const embeddedIframeContainerStyle = isEmbedded ? iframeContainerStyle : {};
  
  const renderPrivacyTerms = () => {
    const showPrivacyTermsFooter = true; //HelperWebView.isAndroidWebview();
    return (
      <>
        <footer className="footer h-100 d-flex flex-column pt-3">
          <div className="d-flex flex-fill" />  {/* Spacer to push footer content down */}
          {showPrivacyTermsFooter && (
            <div className="d-inline-flex justify-content-center align-items-center">
              <LinkButton
                onClick={() => Emitter.emit("OPEN_IAGREE_TEXT", null)}
                styleClass="link-container ms-0 ms-md-2"
                textClass="small"
                valueText="Política de Privacidade"
              />
              <span className="mx-2 small">|</span>
              <LinkButton
                onClick={() => window.open('https://www.keymaster.pt/termos-e-condicoes/', '_self')}
                styleClass="link-container ms-0 ms-md-2"
                textClass="small"
                valueText="Termos & Condições"
              />
            </div>
          )}
        </footer>
      </>
    )
  }
  
  return (
    <div className={`main-page-container pb-1 pt-4 align-center justify-content-start ${isEmbedded ? 'mt-0 ' : 'mt-0 container'}`} style={embeddedContainerStyle}>
      {!isEmbedded &&
        <>
          <div className="company-logo-container mt-2 mt-md-4" onClick={() => navigate("/")}>
            <img className="kmclient-logo"
              src={domain ? CompanyService.urlCompanyImage(`domain/${domain}`) : IconClient}
              alt="logo"
              onError={(e) => ((e.target as HTMLImageElement).src = IconClient)} />
          </div>
        </>
      }
      {isEmbedded && renderEmbeddedHeader()}
      {isEmbedded ? (
        <div style={embeddedIframeContainerStyle}>
        <div onClick={returnToLite} style={closeButtonStyle} > &times; </div>
        <h3 className="text-center w-100 my-4">{open_appointment ? RegisterLabels.header_appointment : RegisterLabels.header}</h3>

        <div className="grey-box-container py-4 px-6 w-100">
          <div className="box-form-container">
            {renderUsernameInput()}
            {(phone || email) && renderIAgree()}
            {renderSMSCodeInput()}
            {renderDummyContinuarButton()}
            {renderEmailPasswordFieldAndButton()}
            {renderRequestPhoneOTPButton()}
            {renderLoginPhoneButton()}

          </div>
        </div>

        {((iAgree && (phone || email))
          || (!phone && !email)) &&
          <>
            <ButtonDivider />

            {!phone && !email && renderIAgree()}
            <LoginProvider provider="google" navigate={navigate} iAgreeNotSet={iAgreeNotSet} iagree={iAgree} />
            <LoginProvider provider="apple" navigate={navigate} iAgreeNotSet={iAgreeNotSet} iagree={iAgree} />
          </>
        }
        {renderGoToLoginLink()}
        {!isEmbedded &&
          <>
            {renderDeleteAccountLink()}
            <div className="powered-by-container mt-3">
              {" "}
              <PoweredBy />
            </div>
          </>
        }
        {renderModalInformation(modalInfoOnConfirm)}
      </div>
      )
        :
        (<>
          <h3 className="text-center w-100 my-4">{open_appointment ? RegisterLabels.header_appointment : RegisterLabels.header}</h3>

          <div className="grey-box-container py-4 px-6 w-100">
            <div className="box-form-container">
              {renderUsernameInput()}
              {(phone || email) && renderIAgree()}
              {renderSMSCodeInput()}
              {renderDummyContinuarButton()}
              {renderEmailPasswordFieldAndButton()}
              {renderRequestPhoneOTPButton()}
              {renderLoginPhoneButton()}

            </div>
          </div>

          {((iAgree && (phone || email))
            || (!phone && !email)) &&
            <>
              <ButtonDivider />

              {!phone && !email && renderIAgree()}
              <LoginProvider provider="google" navigate={navigate} iAgreeNotSet={iAgreeNotSet} iagree={iAgree} />
              <LoginProvider provider="apple" navigate={navigate} iAgreeNotSet={iAgreeNotSet} iagree={iAgree} />
            </>
          }
          {renderGoToLoginLink()}
          {!isEmbedded &&
            <>
              {renderDeleteAccountLink()}
              <div className="powered-by-container mt-3">
                {" "}
                <PoweredBy />
              </div>
            </>
          }
          {renderPrivacyTerms()}
          {renderModalInformation(modalInfoOnConfirm)}
        </>)}
    </div>
  );
};

export default Register;
